var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.speaker.content_code
    ? _c(
        "div",
        { staticClass: "card mb-2" },
        [
          _c("favorite", {
            attrs: {
              attr: "speaker",
              value: _vm.speaker.content_code,
              obj: _vm.speaker,
              "extra-css": "p-2 ml-auto",
            },
            on: {
              "favorite-changed": function ($event) {
                return _vm.$emit("favorite-changed", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "avatar mx-auto",
            attrs: { src: _vm.speaker.profile_img_url },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body text-center" },
            [
              _c("h4", { staticClass: "card-title mb-0" }, [
                _vm._v(_vm._s(_vm.speakerFullName(_vm.speaker))),
              ]),
              _vm._v(" "),
              _vm.speaker.job_title
                ? _c("p", { staticClass: "text-muted" }, [
                    _c("small", [_vm._v(_vm._s(_vm.speaker.job_title))]),
                    _vm._v(" "),
                    _vm.speaker.sessions_chaired.length
                      ? _c("small", [_c("br"), _vm._v("Moderator:in")])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.speaker.company
                ? _c("p", [_vm._v(_vm._s(_vm.speaker.company))])
                : _vm._e(),
              _vm._v(" "),
              _vm.speaker.mm_user_id
                ? _c("channel-private-button", {
                    attrs: { contactId: _vm.speaker.mm_user_id },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.speaker.description
                ? [
                    _c("h3", { staticClass: "text-start" }, [
                      _vm._v("Biographie"),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "text-start mb-3",
                      domProps: { innerHTML: _vm._s(_vm.speaker.description) },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("h3", { staticClass: "text-start" }, [_vm._v("Sessions")]),
              _vm._v(" "),
              _vm._l(
                _vm.filteredSessions(_vm.speaker.sessions),
                function (talk) {
                  return _c("talk-detail", {
                    key: talk.id,
                    staticClass: "mb-3 text-start",
                    attrs: {
                      talk: talk,
                      "language-display": false,
                      "list-display": true,
                    },
                    on: {
                      "favorite-changed": function ($event) {
                        return _vm.$emit("mark", $event)
                      },
                    },
                  })
                }
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h3", { staticClass: "text-start" }, [
                _vm._v("Moderierte Sessions"),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.filteredSessions(_vm.speaker.sessions_chaired),
                function (talk) {
                  return _c("talk-detail", {
                    key: talk.id,
                    staticClass: "mb-3 text-start",
                    attrs: {
                      talk: talk,
                      "language-display": false,
                      "list-display": true,
                    },
                    on: {
                      "favorite-changed": function ($event) {
                        return _vm.$emit("mark", $event)
                      },
                    },
                  })
                }
              ),
            ],
            2
          ),
        ],
        1
      )
    : _c("div", [
        _c("h2", { staticClass: "text-center" }, [_vm._v("not found")]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }